import { useCallback, useState } from 'react';

import type { DrillDownContext, ViewType, VolumeType } from '../types';

interface NavigationState {
  viewType: ViewType;
  volumeType: VolumeType;
  drillDownContext: DrillDownContext | null;
}

export function useBrandsProductsNavigation() {
  const [state, setState] = useState<NavigationState>({
    viewType: 'brands',
    volumeType: 'mention',
    drillDownContext: null,
  });

  const setViewType = useCallback((viewType: ViewType) => {
    setState((prev) => ({
      ...prev,
      viewType,
      drillDownContext: null, // Reset drill-down when switching tabs
    }));
  }, []);

  const setVolumeType = useCallback((volumeType: VolumeType) => {
    setState((prev) => ({
      ...prev,
      volumeType,
    }));
  }, []);

  const drillDown = useCallback((context: DrillDownContext) => {
    setState((prev) => ({
      ...prev,
      drillDownContext: context,
    }));
  }, []);

  const goBack = useCallback(() => {
    setState((prev) => ({
      ...prev,
      drillDownContext: null,
    }));
  }, []);

  const isDrillDown = state.drillDownContext !== null;

  return {
    viewType: state.viewType,
    volumeType: state.volumeType,
    drillDownContext: state.drillDownContext,
    isDrillDown,
    setViewType,
    setVolumeType,
    drillDown,
    goBack,
  };
}
